
const photocard_images = [
    {
        title: "Choerry",
        thumbnail:process.env.PUBLIC_URL+ '/images/ARTMS_Birth_visuals_Choerry_2.webp',
        url: "https://youtu.be/03pOwBH_ML8?si=NuWwLL4TuHzxawEq"
    },
    {
        title: "Chuu",
        thumbnail:process.env.PUBLIC_URL+ '/images/chuu.jpg',
        url: "https://youtu.be/JRbXa1w-Pa8?si=gQJ46NQpPm9yQmPc"
    },
    {
        title: "Heejin",
        thumbnail:process.env.PUBLIC_URL+ '/images/heejin.webp',
        url: "https://www.youtube.com/watch?v=wUWCRKTzDLs"
    },
]

export default photocard_images;